import React from "react";
// import {AuthProvider} from './auth-context'
import { UserProvider } from "@dreamchimney/user-context";

function AppProviders({ children }) {
  return <UserProvider>{children}</UserProvider>;
}

export default AppProviders;
